const allRoutes = {
  viaStructure: '/',
  exploreStackUp: (id) => `/explore-stack-up/${id}`,
  stackUpListing: '/explore-stack-up',
  stackUpDetails: (id) => `/stack-up-details/${id}`,
  editStackUp: (iProjectId) => `/stack-up/${iProjectId}`,
  login: '/login',
  forgotPassword: '/forgot-password',
  signUp: '/sign-up',
  verification: '/verification',
  emailVerification: (token) => `/email-verification/${token}`,
  projects: '/projects',
  materialListing: '/material-listing',
  cms: (slug) => `/content/${slug}`
}
export default allRoutes
